module.exports = __webpack_public_path__ + "media/images/icons/plus-646826b1cf8dc479f1a9c5f7505af18b.svg";